import {List, Record} from 'immutable';
import Team from 'records/Team';
import {FilterWordProfileId} from 'records/admin/topics/NewFilterWordProfile';
import {RecordProps} from '@store/@types/util';

/**
 * A department together with the teams it contains.
 */
export default class DepartmentWithTeams extends Record({
  id: undefined, // alias for departmentId. TODO can we get rid of this?
  departmentId: undefined,
  name: undefined,
  filterWordProfileId: undefined,
  teams: List(),
}) {
  readonly id: string | undefined;
  readonly departmentId: string | undefined;
  readonly name: string | undefined;
  readonly filterWordProfileId: FilterWordProfileId;
  readonly teams: List<Team>;

  constructor(object: RecordProps<DepartmentWithTeams> = {}) {
    super(
      Object.assign({}, object, {
        id: object.departmentId,
        teams: List((object.teams ?? []).map(team => new Team(team))),
      })
    );
  }
}
